var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-box"},[_c('xr-table',{ref:"xrTable",staticStyle:{"width":"100%","height":"100%"},attrs:{"configure":_vm.configure}}),_vm._v(" "),_c('xr-upload',{ref:"xrUploadDialog",attrs:{"targetId":_vm.businessId,"business-type":_vm.businessType},on:{"confirmMethod":function($event){return _vm.uploadSuccess(arguments)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8bf828","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/XrResource/index.vue
// module id = null
// module chunks = 